<template>
    <section id="about" class="about-us ptb-100 position-relative">
        <div class="container">
            <div class="row align-items-center justify-content-lg-between justify-content-md-center">
                <div class="col-md-5 col-lg-4">
                    <div class="about-content-right">
                        <img src="../../assets/img/bbr-img/350x625 Parcel.jpg" alt="about us" class="img-fluid">
                    </div>
                </div>
                <div class="col-md-12 col-lg-7">
                    <div class="about-content-left section-heading">
                        <h2>Why parcel Delivery?</h2>

                        <ul class="check-list-wrap pt-3">
                            <li><strong>Delivered Safely and with Care</strong> – BBR makes sure to deliver your parcel with safety and care.</li>
                            <li><strong>Competitive Pricing</strong> – We have the most affordable price compare to our services.</li>
                            
                            <li><strong>Delivery with Peace of Mind</strong> – Get fast support whenever you need it.</li>
                            <!-- <li><strong>Big Data Analytics</strong> – Quickly incubate revolutionary data and effective infomediaries. Credibly transform high standards in convergence via market positioning interfaces.</li> -->
                        </ul>
                        <!-- <div class="action-btns mt-4">
                            <a href="#" class="btn btn-brand-02 mr-3">Get Start Now</a>
                            <a href="#" class="btn btn-outline-brand-02">Learn More</a>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'About',
        props: {
            isGray: {
                type: Boolean,
                default: false
            }
        }
    }
</script>